import React from "react";
import { useLoaderData } from "react-router";
import { Link } from "react-router-dom";

import BannedTeams from "./components/BannedTeams";
import Schedule from "./components/Schedule";
import UmpireInfo from "./components/UmpireInfo";
import UmpireRatings from "./components/UmpireRatings";

import { useUmpiresContext } from "../../contexts/Umpires";

import { store } from "../../../../..";
import { globalActions } from "../../../../../features/global/globalSlice";
import { getUmpire, getUmpireRatings } from "../../../../../lib/api";
import { IUmpireRating, IUmpireUser } from "../../../../../types/api";

export const loader = async ({ params }: any) => {
    const { umpireId } = params;
    const { settings, sites } = store.getState().global;
    const promises = [];
    !sites.length && promises.push(store.dispatch(globalActions.getSites()));
    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));

    const [{ umpire }, { ratings }] = await Promise.all([
        getUmpire(umpireId),
        getUmpireRatings(umpireId),
        ...promises,
    ]);

    return {
        umpire,
        ratings,
    };
};

const Umpire = (): React.ReactNode => {
    const { umpire, ratings: gameRatings } = useLoaderData() as {
        umpire: IUmpireUser;
        ratings: IUmpireRating[];
    };
    const { type } = useUmpiresContext();

    return (
        <>
            <Link to={`/admin/umpires/${type}`}>
                Back to {type} umpires list
            </Link>
            <UmpireInfo umpire={umpire} />
            <UmpireRatings year="current" umpire={umpire} />
            <UmpireRatings year="past" umpire={umpire} />
            <BannedTeams umpire={umpire} />
            <Schedule umpire={umpire} gameRatings={gameRatings} />
        </>
    );
};

export default Umpire;
